
import {Component, Vue, Watch} from 'vue-property-decorator'
import CourierInfo from '@/model/modules/CourierInfo'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import PostCodeService from '@/service/modules/PostCodeService'
import PostCodeInfo from '@/model/modules/PostCodeInfo'

@Component
export default class PostcodeDataEditor extends Vue {
  item: CourierInfo = new CourierInfo()
  showState: boolean = false
  dataLoadingState: boolean = false
  courierList: CourierInfo[] = []

  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '数据ID', value: 'id'},
    {text: '邮政编码', value: 'postcode'},
    {text: '区域编号', value: 'area'},
    {text: '附加费', value: 'additionalFees'},
    {text: '备注', value: 'remark'}
  ]

  queryLikeResult: BasePageableInfo<PostCodeInfo> = new BasePageableInfo<PostCodeInfo>()
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  uploadPanelShowState: boolean = false
  uploadingState: boolean = false
  // @ts-ignore
  uploadUrl: string = window.$HOST + '/order/import_postcode'
  uploadHeaders: any = axios.defaults.headers

  mounted() {
  }

  showEditor(item: CourierInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.showState = true
    this.loadAllData()
    // @ts-ignore
    this.uploadUrl = window.$HOST + '/order/import_postcode?channel=' + this.item.id
  }

  @Watch('pageSize')
  onPageSizeChanged() {
    this.loadAllData()
  }

  @Watch('pageNum')
  loadAllData() {
    this.listLoadingState = true
    PostCodeService.list({courierId: this.item.id}, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<PostCodeInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  beforeUpload() {
    this.uploadingState = true
  }

  uploadSuccess() {
    this.loadAllData()
    this.uploadingState = false
    this.$notify({
      title: 'Excel上传结束',
      message: '上传成功'
    })
    // @ts-ignore
    this.$refs.uploader.clearFiles()
    this.uploadPanelShowState = false
  }
}
